import {
  cloneElement,
  isValidElement,
  type MouseEventHandler,
  type PropsWithChildren,
} from 'react';

type Props = PropsWithChildren & {
  onClick: MouseEventHandler<HTMLElement>;
};

export const ToggleOverlayBtn = ({ onClick, children }: Props) =>
  isValidElement(children) ? (
    cloneElement(children, {
      onClick: onClick,
      ...children.props,
    })
  ) : !!children ? (
    <span className="inline-flex items-center" onClick={onClick}>
      {children}
    </span>
  ) : null;
